export default "__VITE_ASSET__DXsjVnxN__"